// ============================================================================
// 9'One Store — Phase 1 Product Catalog (PLACEHOLDER DATA)
// ----------------------------------------------------------------------------
// IMPORTANT: These are TEMPORARY placeholder products with stock imagery and
// placeholder names/prices/measurements. They are NOT real 9'One inventory.
// Replace this file with real data (or a future API/database response) later.
// The UI only reads from these structures, so nothing else needs to change.
// ============================================================================

// Style / collection buckets used across Shop, Collections & "Shop by Style".
export const COLLECTIONS = [
  {
    slug: "oversized",
    name: "Oversized",
    tagline: "Boxy, dropped-shoulder silhouettes",
    image:
      "https://images.unsplash.com/photo-1571455786673-9d9d6c194f90?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwxfHxibGFjayUyMHQtc2hpcnQlMjBwcm9kdWN0JTIwc3R1ZGlvfGVufDB8fHx8MTc4NzAzNDY0Nnww&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "essentials",
    name: "Essentials",
    tagline: "Everyday staples, done right",
    image:
      "https://images.unsplash.com/photo-1692003509966-80ca67c85068?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwyfHx3aGl0ZSUyMHQtc2hpcnQlMjBwcm9kdWN0JTIwbWluaW1hbHxlbnwwfHx8fDE3ODcwMzQ2NDZ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "graphics",
    name: "Graphics",
    tagline: "Statement prints & artwork",
    image:
      "https://images.unsplash.com/photo-1721637686340-de9f8cebda5a?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODB8MHwxfHNlYXJjaHwyfHxzdHJlZXR3ZWFyJTIwbW9kZWwlMjBwb3J0cmFpdCUyMGVkaXRvcmlhbHxlbnwwfHx8fDE3ODcwMzQ2NDZ8MA&ixlib=rb-4.1.0&q=85",
  },
  {
    slug: "minimal",
    name: "Minimal",
    tagline: "Clean, quiet, considered",
    image:
      "https://images.unsplash.com/photo-1620799139507-2a76f79a2f4d?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2ODl8MHwxfHNlYXJjaHwzfHxwbGFpbiUyMGNvbG9yZWQlMjB0LXNoaXJ0JTIwZmxhdGxheXxlbnwwfHx8fDE3ODcwMzQ2NDZ8MA&ixlib=rb-4.1.0&q=85",
  },
];

export const CATEGORIES = ["T-Shirts"];

export const SIZES = ["S", "M", "L", "XL", "XXL"];

// Color reference palette (swatch hex values).
const C = {
  black: { name: "Black", hex: "#0A0A0A" },
  white: { name: "White", hex: "#F5F5F0" },
  cream: { name: "Cream", hex: "#E7E1D3" },
  charcoal: { name: "Charcoal", hex: "#3A3A3A" },
  olive: { name: "Olive", hex: "#5B6236" },
  navy: { name: "Navy", hex: "#1F2A44" },
  burgundy: { name: "Burgundy", hex: "#5C1A2B" },
};

const CARE =
  "Placeholder care: Machine wash cold, inside out. Do not bleach. Tumble dry low. Warm iron if needed. (Final care instructions to be confirmed.)";

export const products = [
  {
    id: "9one-001",
    slug: "obsidian-oversized-tee",
    name: "Obsidian Oversized Tee",
    description:
      "A heavyweight oversized tee with a boxy fit and dropped shoulders. Placeholder description — final product copy to be added.",
    price: 1299,
    compareAtPrice: 1699,
    category: "T-Shirts",
    collection: "oversized",
    colors: [C.black, C.charcoal],
    sizes: SIZES,
    material: "Placeholder: 240 GSM combed cotton",
    fit: "Oversized / boxy",
    careInstructions: CARE,
    badges: ["NEW", "SALE"],
    featured: true,
    newArrival: true,
    placeholder: true,
    images: [
      "https://images.pexels.com/photos/9558567/pexels-photo-9558567.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=900",
      "https://images.unsplash.com/photo-1610502778270-c5c6f4c7d575?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
      "https://images.unsplash.com/photo-1499971442178-8c10fdf5f6ac?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
      "https://images.pexels.com/photos/35625406/pexels-photo-35625406.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=900",
    ],
  },
  {
    id: "9one-002",
    slug: "core-white-essential-tee",
    name: "Core White Essential Tee",
    description:
      "The everyday white tee — soft, breathable and built for rotation. Placeholder description.",
    price: 999,
    compareAtPrice: null,
    category: "T-Shirts",
    collection: "essentials",
    colors: [C.white, C.cream],
    sizes: SIZES,
    material: "Placeholder: 180 GSM ring-spun cotton",
    fit: "Regular",
    careInstructions: CARE,
    badges: ["BESTSELLER"],
    featured: true,
    newArrival: false,
    placeholder: true,
    images: [
      "https://images.pexels.com/photos/11671964/pexels-photo-11671964.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=900",
      "https://images.unsplash.com/photo-1692003509966-80ca67c85068?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
      "https://images.unsplash.com/photo-1620799139507-2a76f79a2f4d?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    ],
  },
  {
    id: "9one-003",
    slug: "off-white-relaxed-tee",
    name: "Off-White Relaxed Tee",
    description:
      "A relaxed cream tee with a lived-in feel. Placeholder description.",
    price: 1099,
    compareAtPrice: null,
    category: "T-Shirts",
    collection: "essentials",
    colors: [C.cream, C.white],
    sizes: ["S", "M", "L", "XL"],
    material: "Placeholder: 200 GSM cotton",
    fit: "Relaxed",
    careInstructions: CARE,
    badges: ["NEW"],
    featured: false,
    newArrival: true,
    placeholder: true,
    images: [
      "https://images.unsplash.com/photo-1620799139834-6b8f844fbe61?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
      "https://images.unsplash.com/photo-1508427953056-b00b8d78ebf5?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    ],
  },
  {
    id: "9one-004",
    slug: "olive-boxy-tee",
    name: "Olive Boxy Tee",
    description:
      "Muted olive with a boxy, structured drape. Placeholder description.",
    price: 1199,
    compareAtPrice: null,
    category: "T-Shirts",
    collection: "oversized",
    colors: [C.olive, C.black],
    sizes: SIZES,
    material: "Placeholder: 220 GSM cotton",
    fit: "Oversized / boxy",
    careInstructions: CARE,
    badges: ["NEW"],
    featured: false,
    newArrival: true,
    placeholder: true,
    images: [
      "https://images.unsplash.com/photo-1759572095384-1a7e646d0d4f?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
      "https://images.unsplash.com/photo-1562157873-818bc0726f68?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    ],
  },
  {
    id: "9one-005",
    slug: "navy-everyday-tee",
    name: "Navy Everyday Tee",
    description:
      "A deep navy staple that pairs with anything. Placeholder description.",
    price: 999,
    compareAtPrice: 1299,
    category: "T-Shirts",
    collection: "essentials",
    colors: [C.navy, C.black],
    sizes: ["M", "L", "XL", "XXL"],
    material: "Placeholder: 190 GSM cotton",
    fit: "Regular",
    careInstructions: CARE,
    badges: ["SALE"],
    featured: false,
    newArrival: false,
    placeholder: true,
    images: [
      "https://images.unsplash.com/photo-1562157873-818bc0726f68?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
      "https://images.pexels.com/photos/18186105/pexels-photo-18186105.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=900",
    ],
  },
  {
    id: "9one-006",
    slug: "washed-charcoal-tee",
    name: "Washed Charcoal Tee",
    description:
      "Garment-washed charcoal with a soft matte finish. Placeholder description.",
    price: 1249,
    compareAtPrice: null,
    category: "T-Shirts",
    collection: "minimal",
    colors: [C.charcoal, C.black],
    sizes: SIZES,
    material: "Placeholder: 210 GSM washed cotton",
    fit: "Regular",
    careInstructions: CARE,
    badges: [],
    featured: true,
    newArrival: false,
    placeholder: true,
    images: [
      "https://images.unsplash.com/photo-1571455786673-9d9d6c194f90?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
      "https://images.unsplash.com/photo-1610502778270-c5c6f4c7d575?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    ],
  },
  {
    id: "9one-007",
    slug: "burgundy-statement-tee",
    name: "Burgundy Statement Tee",
    description:
      "A rich burgundy tee with a confident, editorial presence. Placeholder description.",
    price: 1399,
    compareAtPrice: null,
    category: "T-Shirts",
    collection: "graphics",
    colors: [C.burgundy, C.black],
    sizes: ["M", "L", "XL"],
    material: "Placeholder: 230 GSM cotton",
    fit: "Regular",
    careInstructions: CARE,
    badges: ["NEW"],
    featured: true,
    newArrival: true,
    placeholder: true,
    images: [
      "https://images.pexels.com/photos/19583558/pexels-photo-19583558.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=900",
      "https://images.unsplash.com/photo-1562157873-818bc0726f68?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    ],
  },
  {
    id: "9one-008",
    slug: "mono-graphic-tee",
    name: "Mono Graphic Tee",
    description:
      "Minimal monochrome graphic on a crisp white body. Placeholder description.",
    price: 1349,
    compareAtPrice: 1799,
    category: "T-Shirts",
    collection: "graphics",
    colors: [C.white, C.black],
    sizes: SIZES,
    material: "Placeholder: 200 GSM cotton",
    fit: "Regular",
    careInstructions: CARE,
    badges: ["BESTSELLER", "SALE"],
    featured: false,
    newArrival: false,
    placeholder: true,
    images: [
      "https://images.unsplash.com/photo-1644263755671-49b07f7624a6?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
      "https://images.unsplash.com/photo-1513188447171-ecf00455f051?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    ],
  },
  {
    id: "9one-009",
    slug: "street-graphic-tee",
    name: "Street Graphic Tee",
    description:
      "An after-dark graphic tee built for the street. Placeholder description.",
    price: 1449,
    compareAtPrice: null,
    category: "T-Shirts",
    collection: "graphics",
    colors: [C.black, C.white],
    sizes: SIZES,
    material: "Placeholder: 220 GSM cotton",
    fit: "Relaxed",
    careInstructions: CARE,
    badges: ["NEW"],
    featured: true,
    newArrival: true,
    placeholder: true,
    images: [
      "https://images.unsplash.com/photo-1721637686340-de9f8cebda5a?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
      "https://images.unsplash.com/photo-1721637635502-b0abaaa75edb?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    ],
  },
  {
    id: "9one-010",
    slug: "minimal-line-tee",
    name: "Minimal Line Tee",
    description:
      "Quiet and clean — a minimal tee for a considered wardrobe. Placeholder description.",
    price: 1099,
    compareAtPrice: null,
    category: "T-Shirts",
    collection: "minimal",
    colors: [C.white, C.black],
    sizes: SIZES,
    material: "Placeholder: 185 GSM cotton",
    fit: "Regular",
    careInstructions: CARE,
    badges: [],
    featured: false,
    newArrival: false,
    placeholder: true,
    images: [
      "https://images.unsplash.com/photo-1620799139507-2a76f79a2f4d?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
      "https://images.unsplash.com/photo-1692003509966-80ca67c85068?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
    ],
  },
  {
    id: "9one-011",
    slug: "relaxed-fit-black-tee",
    name: "Relaxed Fit Black Tee",
    description:
      "An easy, relaxed black tee for everyday wear. Placeholder description.",
    price: 1199,
    compareAtPrice: null,
    category: "T-Shirts",
    collection: "oversized",
    colors: [C.black],
    sizes: ["L", "XL", "XXL"],
    material: "Placeholder: 210 GSM cotton",
    fit: "Relaxed",
    careInstructions: CARE,
    badges: [],
    featured: false,
    newArrival: true,
    placeholder: true,
    images: [
      "https://images.unsplash.com/photo-1499971442178-8c10fdf5f6ac?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
      "https://images.pexels.com/photos/35625406/pexels-photo-35625406.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=900",
      "https://images.pexels.com/photos/9558567/pexels-photo-9558567.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=900",
    ],
  },
  {
    id: "9one-012",
    slug: "essential-basics-tee",
    name: "Essential Basics Tee",
    description:
      "The core basics tee in black and white. Placeholder description.",
    price: 1599,
    compareAtPrice: 1999,
    category: "T-Shirts",
    collection: "essentials",
    colors: [C.black, C.white],
    sizes: SIZES,
    material: "Placeholder: 190 GSM cotton",
    fit: "Regular",
    careInstructions: CARE,
    badges: ["BESTSELLER", "SALE"],
    featured: true,
    newArrival: false,
    placeholder: true,
    images: [
      "https://images.pexels.com/photos/18186105/pexels-photo-18186105.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=900",
      "https://images.pexels.com/photos/8532616/pexels-photo-8532616.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=1200&w=900",
    ],
  },
];

// ---------------------------------------------------------------------------
// Data-access helpers (swap these to hit a real API later).
// ---------------------------------------------------------------------------
export const getAllProducts = () => products;

export const getProductBySlug = (slug) =>
  products.find((p) => p.slug === slug) || null;

export const getProductById = (id) => products.find((p) => p.id === id) || null;

export const getFeaturedProducts = () => products.filter((p) => p.featured);

export const getNewArrivals = () => products.filter((p) => p.newArrival);

export const getCollectionBySlug = (slug) =>
  COLLECTIONS.find((c) => c.slug === slug) || null;

export const getProductsByCollection = (slug) =>
  products.filter((p) => p.collection === slug);

export const getRelatedProducts = (product, limit = 4) => {
  if (!product) return [];
  const related = products.filter(
    (p) => p.id !== product.id && p.collection === product.collection
  );
  const fallback = products.filter(
    (p) => p.id !== product.id && p.collection !== product.collection
  );
  return [...related, ...fallback].slice(0, limit);
};

export const priceBounds = () => {
  const prices = products.map((p) => p.price);
  return { min: Math.min(...prices), max: Math.max(...prices) };
};
